export default __webpack_public_path__ + "static/media/header-frame.fd9f8da1.webp";